import * as React from 'react';
import { Pie, PieChart } from 'recharts';

import { ChartContainer } from './chart';

const chartConfig = {
  male: {
    label: 'Male',
  },
  female: {
    label: 'Female',
  },
  other: {
    label: 'Other',
  },
};

export function GenderChart({
  male,
  female,
  other,
}: {
  male?: number;
  female?: number;
  other?: number;
}) {
  const chartData = React.useMemo(() => {
    const data = [];
    if (male) {
      data.push({
        gender: 'male',
        count: male,
        fill: 'var(--media-kit-chart-background-primary)',
      });
    }
    if (female) {
      data.push({
        gender: 'female',
        count: female,
        fill: 'var(--media-kit-chart-background-secondary)',
      });
    }
    if (other) {
      data.push({
        gender: 'other',
        count: other,
        fill: 'var(--media-kit-chart-background-tertiary)',
      });
    }
    return data;
  }, [male, female, other]);

  return (
    <div className="flex h-full flex-col gap-3 rounded-8 border border-[var(--media-kit-background-alpha)] bg-[var(--media-kit-background-primary)] p-4">
      <h3 className="text-16 font-500 text-[var(--media-kit-text-base)]">
        Gender distribution
      </h3>
      <div className="flex size-full items-center gap-4">
        <ChartContainer
          config={chartConfig}
          className="aspect-square w-full outline-none [&_*]:outline-none"
        >
          <PieChart>
            <Pie
              data={chartData}
              dataKey="count"
              nameKey="gender"
              isAnimationActive={false}
              pointerEvents="none"
              innerRadius={44}
              strokeWidth={2}
              stroke="var(--media-kit-background-primary)"
            />
          </PieChart>
        </ChartContainer>

        <div className="flex items-center justify-center px-4">
          <div className="flex flex-col gap-2">
            {male ? (
              <div>
                <div className="flex items-center gap-1">
                  <div className="size-3 rounded-[2px] bg-[var(--media-kit-chart-background-primary)]"></div>
                  <span className="text-16 font-500 text-[var(--media-kit-text-subtle)]">
                    Male
                  </span>
                </div>
                <div>
                  <span className="text-24 font-500 text-[var(--media-kit-text-base)]">
                    {male}%
                  </span>
                </div>
              </div>
            ) : null}
            {female ? (
              <div>
                <div className="flex items-center gap-1">
                  <div className="size-3 rounded-[2px] bg-[var(--media-kit-chart-background-secondary)]"></div>
                  <span className="text-16 font-500 text-[var(--media-kit-text-subtle)]">
                    Female
                  </span>
                </div>
                <div>
                  <span className="text-24 font-500 text-[var(--media-kit-text-base)]">
                    {female}%
                  </span>
                </div>
              </div>
            ) : null}
            {other ? (
              <div>
                <div className="flex items-center gap-1">
                  <div className="size-3 rounded-[2px] bg-[var(--media-kit-chart-background-tertiary)]"></div>
                  <span className="text-16 font-500 text-[var(--media-kit-text-subtle)]">
                    Other
                  </span>
                </div>
                <div>
                  <span className="text-24 font-500 text-[var(--media-kit-text-base)]">
                    {other}%
                  </span>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
